export const PROPHETX_SIGNUP_PROMO_CODE = "UPSIDE";
export const PROPHETX_SIGNUP_OFFER_HEADLINE = "TRADE $50, EARN $75";
export const PROPHETX_SIGNUP_OFFER_DETAILS =
  "Trade $50 and earn $75 as a new user bonus.";
export const PROPHETX_SIGNUP_CTA_AMOUNT = "$75";

export const KALSHI_SIGNUP_PROMO_CODE = "UPSIDE";
export const KALSHI_SIGNUP_OFFER_HEADLINE = "TRADE $25, GET $55";
export const KALSHI_SIGNUP_OFFER_DETAILS =
  "Trade $25 and get $55 when you deposit with code UPSIDE.";
export const KALSHI_SIGNUP_CTA_AMOUNT = "$55";

export const DABBLE_SIGNUP_OFFER_HEADLINE = "FREE $10 BONUS";
export const DABBLE_SIGNUP_OFFER_DETAILS =
  "Get a free $10 when you deposit!";

export const PARLAYPLAY_SIGNUP_PROMO_CODE = "UPSIDE";
export const PARLAYPLAY_SIGNUP_OFFER_HEADLINE = "100% MATCH UP TO $100!";
export const PARLAYPLAY_SIGNUP_OFFER_DETAILS =
  "Get a 100% deposit match up to $100 when you sign up.";

export const NOVIG_SIGNUP_PROMO_CODE = "UPSIDE";
export const NOVIG_SIGNUP_OFFER_HEADLINE = "DEPOSIT $10, GET $50 IN TRADE CREDITS";
export const NOVIG_SIGNUP_OFFER_DETAILS =
  "Deposit $10 and get $50 in Trade Credits with code UPSIDE.";
export const NOVIG_SIGNUP_CTA_AMOUNT = "$50";

export const UNDERDOG_SIGNUP_PROMO_CODE = "UPSIDE";
export const UNDERDOG_SIGNUP_OFFER_HEADLINE = "50% FIRST DEPOSIT MATCH UP TO $1,000";
export const UNDERDOG_SIGNUP_OFFER_DETAILS =
  "Get a 50% first-time deposit match up to $1,000 in bonus funds with code UPSIDE.";
export const UNDERDOG_SIGNUP_CTA_AMOUNT = "$1,000";

export const FANDUEL_SIGNUP_OFFER_HEADLINE = "$250 IN BONUS BETS WHEN YOU BET $5 FOR 5 DAYS!";
export const FANDUEL_SIGNUP_OFFER_DETAILS =
  "Get $250 in bonus bets, guaranteed when you bet $5 for 5 days ($50 bonus bets per day).";
export const FANDUEL_SIGNUP_CTA_AMOUNT = "$250";

export const REBET_SIGNUP_OFFER_HEADLINE = "$100 PURCHASE MATCH!";
export const REBET_SIGNUP_OFFER_DETAILS =
  "Get a $100 purchase match on your first deposit.";

export const COURTSIDE_SIGNUP_PROMO_CODE = "UPSIDE";
export const COURTSIDE_SIGNUP_OFFER_HEADLINE = "SPEND $10, GET $100 IN FREE PLAY";
export const COURTSIDE_SIGNUP_OFFER_DETAILS =
  "Spend $10 and get $100 in free play when you sign up through Upside.";

export const CHALKBOARD_SIGNUP_PROMO_CODE = "UPSIDE";
export const CHALKBOARD_SIGNUP_OFFER_HEADLINE = "100% DEPOSIT MATCH UP TO $100 + FREE SQUARE!";
export const CHALKBOARD_SIGNUP_OFFER_DETAILS =
  "Use code UPSIDE for 100% deposit match up to $100 + a free square for your first entry.";

export const SMACKTOK_SIGNUP_PROMO_CODE = "UPSIDE";
export const SMACKTOK_SIGNUP_OFFER_HEADLINE = "$50 FIRST DEPOSIT MATCH + 25% PROFIT BOOST + FREE PICK";
export const SMACKTOK_SIGNUP_OFFER_DETAILS =
  "Use code UPSIDE for a $50 first deposit match, a 25% profit boost and a free mystery player pick.";
export const SMACKTOK_SIGNUP_CTA_AMOUNT = "$50";

export const POLYMARKET_SIGNUP_PROMO_CODE = "UPSIDETOOLS";
export const POLYMARKET_SIGNUP_OFFER_HEADLINE = "$25 TRADING BONUS WITH A $10 DEPOSIT";
export const POLYMARKET_SIGNUP_OFFER_DETAILS =
  "Deposit $10 and get a $25 trading bonus with code UPSIDETOOLS.";
export const POLYMARKET_SIGNUP_CTA_AMOUNT = "$25";

export const SPORTSBOOK_AFFILIATE_LINKS: Record<string, string> = {
  betr: "https://engagebetr.onelink.me/auSX/UPSIDE",
  sleeper: "http://sleeper.com/promo/UPSIDE",
  prophetx: `https://prophetx.onelink.me/E5Yi/${PROPHETX_SIGNUP_PROMO_CODE}`,
  novig: "https://affiliates.routy.app/route/270551?affId=10159&ts=5014763",
  kalshi: "https://kalshi.com/r/upside",
  dabble: "https://affiliates.routy.app/route/267213?affId=10159&ts=5014763",
  parlayplay: "https://parlayplay.io/account/signup?coupon=UPSIDE",
  underdog: "https://play.underdogsports.com/vgwg/p-upside",
  fanduel: "https://platform.routy.app/route/506037?affid=10159&ts=5014763",
  rebet: "https://affiliates.routy.app/route/270544?affId=10159&ts=5014763",
  chalkboard: "https://affiliates.routy.app/route/274655?affId=10159&ts=5014763",
  courtside:
    "https://courtside.onelink.me/5EKN/partners?af_channel=UPSIDE&deep_link_sub4=UPSIDE",
  smacktok: `https://app.smacktok.com/referral/${SMACKTOK_SIGNUP_PROMO_CODE}`,
  fourcx: "https://4cx.io/sign-up/upside",
  polymarket: "https://polymarket-app.onelink.me/S8ac?af_xp=referral&pid=&c=MattDowns&c=SMART&deep_link_sub1=UPSIDETOOLS",
};
